export default {
  save: 'Sauvegarde',
  cancel: 'Annuler',
  ok: 'OK',
  confirm: 'Confirmer',
  information: 'Information',
  confirm_delete:
    'Êtes-vous sûr de vouloir supprimer ? Ça ne peut pas être annulé.',
  invalid_geometry: 'Géométrie non valide',
  no_results: 'Pas de résultats pour cette recherche',
  invalid_lat_long_range:
    'Coordonnées invalides : les valeurs de latitude et de longitude doivent être dans des plages valides.',
  invalid_lat_lon:
    'Les coordonnées fournies ne tombent pas dans la localité sélectionnée.',
  remove_last_vertex: 'Supprimer le dernier sommet',
  dark_mode: 'Mode couleur',
  delete: 'Supprimer',
  delete_vertex: 'Supprimer les sommets',
  draw_dialog_title: 'Instructions de dessin',
  draw_dialog_begin_drawing:
    "Commencer à dessiner - Cliquez n'importe où sur la carte",
  draw_dialog_cancel_drawing: 'Annuler le dessin - Touche ESC',
  draw_dialog_remove_vertex: 'Supprimer le dernier sommet - Clic droit',
  draw_dialog_save: 'Sauvegarder - Double clic',
  draw_dialog_save_single: 'Sauvegarder - Clic simple',
  draw_point: 'Point',
  draw_position: 'Position Actuelle',
  draw_polygon: 'Polygone',
  draw_rectangle: 'Rectangle',
  circle_config: 'Paramétrage du cercle',
  draw_circle: 'Cercle à partir du centre',
  draw_circle_2pt: 'Cercle Manuel',
  radius: 'Rayon',
  units: 'Unité',
  draw_line: 'Ligne',
  create: 'Créer',
  icon_scaling_field: 'Activer/désactiver l’échelle de l’icône de champ',
  icon_scaling_label: 'Échelle de l’icône',
  icon_scaling_cluster: 'Échelle de l’icône de groupe',
  icon_scaling_cluster_log: 'Échelle logarithmique de groupe',
  icon_scaling_zoom_in: 'Échelle de zoom avant',
  icon_scaling_zoom_out: 'Échelle de zoom arrière',
  pill_component_remove: 'Supprimer',
  no_data_filter:
    'Ce champ ne contient aucune donnée et ne peut pas être filtré.',
  filter_searchbox_placeholder: 'Rechercher',
  identical_values_filter:
    'Ce champ contient une seule valeur distincte et ne peut pas être filtré.',
  layer_group_hide_layers: 'Masquer toutes les couches du groupe',
  layer_zoom_to_extent: 'Zoom sur la couche filtrée',
  layer_visibility: 'Modifier la visibilité',
  zoom_to: 'Zoom sur',
  layer_dataview_header: 'Voir les données',
  layer_add_new_location: 'Ajouter un site',
  layer_filter_header: 'Filtre',
  layer_filter_select: 'Sélectionner un filtre de la liste',
  layer_filter_clear_all: 'Enlever tous les filtres',
  layer_filter_reset_all: 'Réinitialiser tous les filtres',
  layer_filter_greater_than: 'Plus grand que',
  layer_filter_less_than: 'Moins que',
  layer_filter_set_filter: 'Définir le filtre',
  layer_style_header: 'Style',
  layer_style_select_theme: 'Sélectionner le style de thématique',
  layer_style_display_labels: 'Afficher les étiquettes',
  layer_style_display_hover: 'Afficher via le curseur',
  layer_style_switch_caption:
    'Cliquez sur les étiquettes pour changer de visibilité ou',
  layer_style_switch_all: 'changer pour tous',
  layer_grid_legend_ratio: 'Afficher la couleur en fonction de la taille',
  layer_style_cluster: 'Emplacements multiples',
  layer_style_opacity: 'Changer l’opacité de la couche :',
  location_clear_all: 'Effacer les emplacements',
  location_listview_full: 'La liste des emplacements est pleine.',
  location_zoom: 'Zoomer sur les contours',
  location_save: 'Enregistrer les modifications',
  location_remove: 'Supprimer depuis la sélection',
  location_delete: "Supprimer l'emplacement",
  location_save_changes: 'Sauvegarder les modifications pour ce site ?',
  location_close_without_save: 'Fermer sans sauvegarder les modifications ?',
  image_upload_failed: "Echec du chargement de l'image.",
  document_upload_failed: 'Echec du chargement du document.',
  remove_image_confirm: 'Êtes-vous sûr de vouloir supprimer cette image ?',
  remove_document_confirm: 'Êtes-vous sûr de vouloir supprimer ce document ?',
  remove_item_confirm: "Supprimer l'élément ?",
  delete_geometry: 'Effacer la Géométrie',
  modify_geometry: 'Modifier la Géométrie',
  edit_dialog_title: 'Modifier les instructions',
  edit_dialog_cancel_drawing:
    'Annuler le dessin - Cliquez sur le bouton d’annulation pour annuler le dessin.',
  edit_dialog_remove_vertex:
    'Supprimer le sommet - Cliquez sur un sommet pour le supprimer.',
  edit_dialog_modify_shape:
    'Modifier la forme - Faites glisser un sommet pour modifier la forme ou ajoutez un nouveau sommet sur le polygone.',
  edit_dialog_save:
    'Enregistrer - Cliquez sur le bouton d’enregistrement pour sauvegarder vos modifications.',
  report: 'Rapport',
  link: 'Lien',
  pin: 'Marquer',
  loading: 'Chargement',
  no_options_available: "Pas d'options disponibles.",
  toolbar_zoom_in: 'Zoom +',
  toolbar_zoom_out: 'Zoom -',
  toolbar_zoom_to_area: 'Zoomer sur la zone',
  toolbar_current_location: 'Emplacement actuel',
  toolbar_fullscreen: 'Carte en plein écran',
  toolbar_admin: 'Ouvrir le menu administrateur',
  toolbar_login: 'Se connecter',
  toolbar_logout: 'Déconnexion',
  layers: 'Couches cartographiques',
  locations: 'Sites',
  no_locales:
    'Votre compte a été vérifié et approuvé, mais vous n’avez accès à aucune localité. Cela est probablement dû au fait qu’un administrateur ne vous a pas attribué les rôles nécessaires. Veuillez contacter un administrateur pour résoudre ce problème.',
  no_layers: 'Aucune couche accessible dans la localité.',
};
